import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { DealerActions } from 'src/app/common/store/actions/dealer.actions';
import { KeepActions } from 'src/app/common/store/actions/keep.actions';

import { selectAllCarImagesFolders, selectDealerFetchingResults, selectProviderCarsByBusinessLine } from 'src/app/common/store/state/app.state';
import { Car } from 'src/app/public/car/models/car.model';
import { AppFunctions } from 'src/app/public/common/constants/app-functions';
import { CarBusinessLine } from 'src/app/public/car/constants/car-basic-data';
import { TransactionStage, TransactionRole } from 'src/app/public/common/constants/common-basic-data';
import { ObjectSource } from 'src/app/public/common/constants/general-basic-data';
import { FileData } from 'src/app/public/common/models/file-data.model';
import { ObjectData } from 'src/app/public/common/models/object-data.model';
import { JobStatus } from 'src/app/public/keep/constants/keep-basic-data';
import { JobDialogComponent } from 'src/app/public/keep/elements/job-dialog/job-dialog.component';
import { Job } from 'src/app/public/keep/models/job.model';

@Component({
    selector: 'app-provider-keep',
    templateUrl: './provider-keep.component.html',
    styleUrls: ['./provider-keep.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class ProviderKeepComponent implements OnInit {

  JobStatus = JobStatus;
  
  myKeepCars$: Observable<Car[]>;
  myKeepCars: Car[] = [];

  carImagesFolders$: Observable<Map<string, Array<FileData>>>;
  
  businessLine: CarBusinessLine = CarBusinessLine.KEEP;
  objectSource: ObjectSource = ObjectSource.KEEP
  transactionStages: TransactionStage[] = [TransactionStage.ONGOING];
  transactionRole: TransactionRole = TransactionRole.PROVIDER

  fetchingResults$: Observable<boolean>;

  TransactionStage = TransactionStage

  constructor(
    private store: Store, 
    private router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog
    ) {

      this.fetchingResults$ = store.select(selectDealerFetchingResults);
      
      this.carImagesFolders$ = store.select(selectAllCarImagesFolders);
      this.myKeepCars$ = store.select(selectProviderCarsByBusinessLine(this.businessLine));
    }

    ngOnInit() {

        this.myKeepCars$.subscribe(
          (res: Car[]) =>  {
            this.myKeepCars = res!.map(c => Object.assign(new Car(), c));
          }
        );

        this.route.data.subscribe(
          data => {
            this.transactionStages = data['transactionStages'];
            this.store.dispatch(DealerActions.providerOffersFetchMySubmit({ transactionRole: this.transactionRole, businessLine: this.businessLine, transactionStages: this.transactionStages}));
          }
        )
        //this.store.dispatch(DealerActions.fetchProviderCarsSubmit({businessLine: this.businessLine, favoritesOnly: false}));
  }

  openJobDialog(carId: string, jobId: number): void {
      
        let objectData: ObjectData = new ObjectData(this.objectSource, carId, jobId );
    
        const dialogRef = this.dialog.open(JobDialogComponent, {
          data: objectData
        });
      }
  
    canNewJob(jobs: Job[]): boolean{
        let index = jobs.findIndex(p => p.status !== JobStatus.CANCELLED)
        return index === -1;
      }

  dateFormat(dt: string): string{

    return AppFunctions.stringToDatetime(dt);
  }
}

